import ensureGoogleAnalytics from '../ensureGoogleAnalytics.js';
export default async function sendClickEvent(data, options) {
  if (data === void 0) {
    data = {};
  }
  if (options === void 0) {
    options = {};
  }
  await ensureGoogleAnalytics(options, dataLayer => {
    dataLayer.push({
      event: 'analytics_event',
      eventAction: 'click',
      eventNonInteractive: false,
      eventData: {},
      ...data
    });
  });
}